import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.sans};
    color: ${({ theme }) => theme.ink};
    background:
      radial-gradient(
        900px 500px at 0% 0%,
        rgba(15, 107, 92, 0.08),
        transparent 60%
      ),
      radial-gradient(
        700px 400px at 100% 10%,
        rgba(155, 102, 44, 0.06),
        transparent 55%
      ),
      ${({ theme }) => theme.bg};
    line-height: 1.5;
  }

  #root {
    min-height: 100vh;
  }

  :where(a, button, input, select, textarea):focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;
